import React from "react";
import TokenLogin from "../components/Token-Login";
import Home from "../pages/home/home";
import { Route } from "react-router-dom";

export default function DefaultRoute() {
  return (
    <Route
      key={0}
      path="/"
      element={
        <>
          <TokenLogin />
          <Home />
        </>
      }
    />
  );
}
